"use client";

import type {Params} from "next/dist/server/request/params";
import {useParams} from "next/navigation";
import Alert from "@/components/alert";
import cn from "@/utils/cn";
import {trackedPlayers, wipes} from "..";

export default function Settings({params}: {params: Params})
{
    params = useParams() ?? params;
    const wipeIndex = Number(params.wipeId) - 1;

    return (
        <>
            <Alert severity="info" className="mb-10 w-full px-2.5">Settings are currently read-only.</Alert>

            <div className="flex gap-5">
                <div>
                    <div className="rounded overflow-hidden border">
                        <table className="">
                            <thead>
                                <tr className="border-b">
                                    <th className="h-10 text-left py-1.5 px-2 bg-neutral-900">Tracked Players</th>
                                </tr>
                            </thead>
                            <tbody>
                                {trackedPlayers[wipeIndex].map((trackedPlayer, i) => 
                                    <tr key={trackedPlayer.name} className={cn("hover:bg-neutral-900/50", i < trackedPlayers[wipeIndex].length - 1 && "border-b")}>
                                        <td className={cn("py-1.5 px-2", trackedPlayer.color)}>{trackedPlayer.name}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div>
                    <div className="rounded overflow-hidden border">
                        <table className="">
                            <thead>
                                <tr className="border-b">
                                    <th className="h-10 text-left py-1.5 px-2 bg-neutral-900">Ignored Weapons</th>
                                </tr>
                            </thead>
                            <tbody>
                                {wipes[wipeIndex].ignoredWeapons.map((weaponName, i) => 
                                    <tr key={weaponName} className={cn("hover:bg-neutral-900/50", i < wipes[wipeIndex].ignoredWeapons.length - 1 && "border-b")}>
                                        <td className="py-1.5 px-2 bg-rose-900">{weaponName}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}
